module.exports = __webpack_public_path__ + "static/media/bumpMusic.86e22d0.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/hjwq/springFestival/mp3/bumpMusic.mp3
// module id = 3Fpe
// module chunks = 5